export default __webpack_public_path__ + "static/megaphone-4b5e9ba409d937cacd5cd6ceb6d85e48.svg";